const templateDomain = "https://template.mt.gov";
const mtgovDomain = "https://mt.gov";

export const MTGOV = {
    pageInitted: false,
    screenMode: '',
    fastLoadAttempts: 0,
    tryFastLoad: function () {
        ++MTGOV.fastLoadAttempts;

        if (!MTGOV.pageInitted && MTGOV.fastLoadAttempts < 500) {
            if (document.getElementById('template-footer') != null)
                MTGOV.initPage();
            else
                window.setTimeout(MTGOV.tryFastLoad, 10);
        }
    },
    onLoad: function () {
        if (!MTGOV.pageInitted)
            MTGOV.initPage();
    },
    windowResize: function (limit) {
        const body = document.body;
        const currentScreenMode = (MTGOV.getWindowWidth() > limit) ? 'desktop' : 'mobile';
        if (currentScreenMode !== MTGOV.screenMode) {
            let className = body.className.replace(" mobile", "").replace("mobile ", "").replace("mobile", "").replace(" desktop", "").replace("desktop ", "").replace("desktop", "");
            const search = document.getElementById("template-search-wrap");
            if ((className.length > 0) && (className.charAt(className.length - 1) !== " ")) {
                className = className + " ";
            }
            if (currentScreenMode === 'desktop') {
                className = className + "desktop";
                document.getElementById("template-search").appendChild(search);
            } else if (currentScreenMode === 'mobile') {
                className = className + "mobile";
                document.getElementById("template-header").appendChild(search);
            }
            MTGOV.screenMode = currentScreenMode;
            body.className = className;
            //console.log('screen size set to ' + MTGOV.screenMode);
        }
    },
    getWindowWidth: function () {
        let screenWidth;
        if (window.innerWidth) {
            screenWidth = window.innerWidth;
        } else if (document.documentElement && document.documentElement.clientWidth) {
            screenWidth = document.documentElement.clientWidth;
        } else if (document.body) {
            screenWidth = document.body.clientWidth;
        }
        return screenWidth;
    },
    Search: function () {
        let qs = "";
        const wrap = document.getElementById("template-search-wrap");
        for (const element of wrap.childNodes) {
            if (element.getAttribute("name") != null) {
                qs = qs + "&" + escape(element.getAttribute("name")) + "=" + escape(element.value);
            }
        }
        qs = qs.replace(/&/, '?');
        window.location.href = "https://montana.gov/search.aspx" + qs;
    }
};

MTGOV.initPage = function () {
    //Create #template-header if it doesn't exist.
    let templateHeader = document.getElementById("template-header");
    if (templateHeader == null) {
        templateHeader = document.createElement("header");
        templateHeader.setAttribute("id", "template-header");
        document.body.insertBefore(templateHeader, document.body.firstChild);
    }

    //Create #template-footer it it doesn't exist.
    let templateFooter = document.getElementById("template-footer");
    if (templateFooter == null) {
        templateFooter = document.createElement("footer");
        templateFooter.setAttribute("id", "template-footer");
        document.body.appendChild(templateFooter);
    }

    //HEADER
    const templateHeaderNav = document.createElement("ul");
    templateHeaderNav.setAttribute("id", "template-header-nav");
    if (templateHeader.childNodes.length > 0) {
        templateHeader.insertBefore(templateHeaderNav, templateHeader.firstChild);
    } else {
        templateHeader.appendChild(templateHeaderNav);
    }

    const Services = document.createElement("a");
    Services.setAttribute("href", "https://directory.mt.gov/online-services");
    Services.innerHTML = "Services";

    let li = document.createElement("li");
    li.appendChild(Services);
    templateHeaderNav.appendChild(li);

    const Agencies = document.createElement("a");
    Agencies.setAttribute("href", "https://mt.gov/govt/agencylisting.aspx");
    Agencies.innerHTML = "Agencies";
    li = document.createElement("li");
    li.appendChild(Agencies);
    templateHeaderNav.appendChild(li);

    let Login = document.createElement("a");
    Login.setAttribute("href", "https://login.mt.gov");
    Login.innerHTML = "Login";
    li = document.createElement("li");
    li.appendChild(Login);
    templateHeaderNav.appendChild(li);

    const templateSearchWrap = document.createElement("div");
    templateSearchWrap.setAttribute("id", "template-search-wrap");
    li = document.createElement("li");
    li.setAttribute("id", "template-search");
    li.appendChild(templateSearchWrap);
    templateHeaderNav.appendChild(li);

    const searchitem = document.createElement("input");
    searchitem.setAttribute("id", "template-search-item");
    searchitem.setAttribute("type", "text");
    searchitem.setAttribute("placeholder", "SEARCH MONTANA.GOV");
    searchitem.setAttribute("name", "q");
    searchitem.setAttribute("aria-label", "Search Montana.gov input field");
    searchitem.addEventListener("click", function (evt) {
            evt.target.value = "";
    });
    searchitem.addEventListener("keypress", function (evt) {
        let keycode = evt.key;
        if (keycode === "Enter") {
            MTGOV.Search();
        }
    });

    templateSearchWrap.appendChild(searchitem);

    const via = document.createElement("input");
    via.setAttribute("type", "hidden");
    via.setAttribute("value", "homepage");
    via.setAttribute("name", "via");
    templateSearchWrap.appendChild(via);

    const cx = document.createElement("input");
    cx.setAttribute("type", "hidden");
    cx.setAttribute("value", "013380590290877010950:3ubczas3i44");
    cx.setAttribute("name", "cx");
    templateSearchWrap.appendChild(cx);

    const cof = document.createElement("input");
    cof.setAttribute("type", "hidden");
    cof.setAttribute("value", "FORID:11");
    cof.setAttribute("name", "cof");
    templateSearchWrap.appendChild(cof);

    const ie = document.createElement("input");
    ie.setAttribute("type", "hidden");
    ie.setAttribute("value", "UTF-8");
    ie.setAttribute("name", "ie");
    templateSearchWrap.appendChild(ie);

    const q = document.createElement("input");
    q.setAttribute("id", "template-search-button");
    q.setAttribute("type", "image");
    q.setAttribute("alt", "MT.gov Search Button");
    q.setAttribute("aria-label", "MT.gov Search Button");
    q.setAttribute("src", templateDomain + "/resources/template/search-icon.png");
    q.addEventListener("click", function () {
        MTGOV.Search();
    });
    templateSearchWrap.appendChild(q);

    const headerHomeAnchor = document.createElement("a");
    headerHomeAnchor.setAttribute("href", mtgovDomain);
    templateHeader.insertBefore(headerHomeAnchor, templateHeader.firstChild);

    const mtlogo = document.createElement("img");
    mtlogo.setAttribute("id", "template-header-logo");
    mtlogo.setAttribute("src", templateDomain + "/resources/template/montanalogo.png");
    mtlogo.setAttribute("alt", "MONTANA.GOV logo");
    mtlogo.setAttribute("width", "248");
    mtlogo.setAttribute("height", "48");
    headerHomeAnchor.appendChild(mtlogo);

    templateHeaderNav.appendChild(li);

    //FOOTER
    const footerlink = document.createElement("a");
    footerlink.setAttribute("href", mtgovDomain);
    templateFooter.appendChild(footerlink);

    const footerlogo = document.createElement("img");
    footerlogo.setAttribute("id", "template-footer-logo");
    footerlogo.setAttribute("src", templateDomain + "/resources/template/montanalogo.png");
    footerlogo.setAttribute("alt", "mt.gov logo");
    footerlogo.setAttribute("width", "248");
    footerlogo.setAttribute("height", "48");
    footerlink.appendChild(footerlogo);

    const footernav = document.createElement("ul");
    footernav.setAttribute("id", "template-footer-nav");
    templateFooter.appendChild(footernav);

    const privacy = document.createElement("a");
    li = document.createElement("li");
    privacy.setAttribute("href", "https://mt.gov/1240-X06.pdf");
    privacy.setAttribute("title", "Privacy & Security Policy");
    privacy.setAttribute("target", "_blank");
    privacy.setAttribute("rel", "noopener");
    privacy.innerHTML = "Privacy & Security";
    li.appendChild(privacy);
    footernav.appendChild(li);

    const accessibility = document.createElement("a");
    li = document.createElement("li");
    accessibility.setAttribute("href", "https://mt.gov/discover/disclaimer.aspx#accessibility");
    accessibility.setAttribute("title", "Accessibility Information");
    accessibility.innerHTML = "Accessibility";
    li.appendChild(accessibility);
    document.getElementById("template-footer-nav").appendChild(li);

    MTGOV.pageInitted = true;
    MTGOV.windowResize();
}
